define('views/parts/alert/alert-list-item',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'src/routes',
    // templates
    'text!templates/parts/alert/alert-list-item.html',
], function(
    // Libs
    _, Backbone, Mustache, U, Routes,
    // templates
    TAlertListItem
) {

    var VAlertListItem = Backbone.View.extend({
        template: TAlertListItem,
        events: {
            "click .close": "onClose",
        },

        initialize: function(opt) {
            // this.options = opt || {};

            this.listenTo(this.model, {
                "remove": this.remove,
            });
        },
        render: function() {
            var $html = Backbone.$(Mustache.render(this.template, Mustache.getContext(this.model.toJSON())));

            this.$el.replaceWith($html);
            this.setElement($html);

            _.delay(this.show.bind(this), 50);

            return this;
        },

        show: function() {
            this.$el.removeClass("transparent");
        },

        onClose: function(e) {
            this.model.trigger("alert:close", this.model);
        },


    });

    return VAlertListItem;

});

